import { Badge, Group } from '@mantine/core';

interface ViewExternalIdBadgeListProps {
  externalIds: readonly (string | undefined)[];
}

export function ViewExternalIdBadgeList({ externalIds }: ViewExternalIdBadgeListProps) {
  if (externalIds.length === 0) {
    return null;
  }
  return (
    <Group gap="xs">
      {externalIds.filter(Boolean).map((externalId, index) => (
        <Badge
          bg="transparent"
          color="grape.2"
          key={`${
            // biome-ignore lint/suspicious/noArrayIndexKey: stable index reference
            index
          }-${externalId}`}
          my={0}
          py={0}
          size="xs"
          variant="dot"
        >
          {externalId
            ?.replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/_/g, ' ')
            .toUpperCase()}
        </Badge>
      ))}
    </Group>
  );
}
